export const _en = {
    name: {
        label: "Name"
    },
    stage: {
        label: "Training course"
    },
    group: {
        label: "Group"
    },
    taskCategory: {
        label: "Activity category"
    },
    taskType: {
        label: "Activity type"
    },
    begining: {
        label: "Beginning"
    },
    end: {
        label: "End"
    },
    refResourceId: {
        label: "Resource"
    },
    refSiteId: {
        label: "Site"
    },
    refPlaneId: {
        label: "Plane type"
    },
    refOrganizationId: {
        label: "Organization"
    },
    isVisualizationDisabled: {
        label: "No view"
    },
    isMotionDisabled: {
        label: "FBS sur FFS"
    },
    refMotorVersionsId: {
        label: "Version"
    },
    comment: {
        label: "Comment"
    },
    homeOffice: {
        label: "Is home office work"
    },
    updated: {
        label: "Last update"
    },
    updatedBy: {
        label: "Last update by"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    taskCategory: {
        label: "Catégorie d'une séance"
    },
    taskType: {
        label: "Type de séance"
    },
    begining: {
        label: "Début"
    },
    end: {
        label: "Fin"
    },
    refResourceId: {
        label: "Ressource"
    },
    refSiteId: {
        label: "Site"
    },
    refPlaneId: {
        label: "Type avion"
    },
    refOrganizationId: {
        label: "Compagnie"
    },
    isVisualizationDisabled: {
        label: "Sans visuel"
    },
    isMotionDisabled: {
        label: "FBS sur FFS"
    },
    refMotorVersionsId: {
        label: "Version"
    },
    comment: {
        label: "Commentaire"
    },
    homeOffice: {
        label: "Ressource en télétravail"
    },
    updated: {
        label: "Date de dernière modification"
    },
    updatedBy: {
        label: "Dernier modificateur"
    }

};